export default __webpack_public_path__ + "static/media/google-setup-1.1c5af646.jpeg";